'use strict';

const urlIp = 'http://119.23.150.122:8050/' //线上
// const url = 'http://192.168.1.17:8080';
// const url = 'https://10.29.254.234:443';
// const url = 'http://192.168.1.17:8082';

const url = {
    login:  'RFC/api/login.do'
};

export default url;



// WEBPACK FOOTER //
// ./src/utils/api/api.js